<template>
  <div class="box7">
    <pageTitle title="专家级老师全程领航 <br/>2个月智能体实战级交付" text="四大实战导师倾力指导，直击智能体核心竞争" />


    <div class="teacher-box">
      <div class="teacher" v-for="(item, index) in list" :key="index" @click="changeCur(index)">
        <img :src="require(`../../../assets/coursePage/agent/07/${index + 1}.png`)" />
        <div class="teacher-inner">
          <div class="tName">{{ item.name }}老师</div>
          <p v-html="item.p"></p>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}老师</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div class="tag" v-for="(item, index) in list[this.cur].tag" :key="index" :class="'tag' + (index + 1)">
            {{ item }}
          </div>
        </div>

        <p v-for="(j, index1) in list[cur].info" :key="index1">
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "潜心",
          b: "AI智能应用开发",
          tag: ["15年央企架构实战专家"],
          p: "15年央企架构实战专家",
          info: [
            "前央企数字中台架构师，主导支付/营销/供应链系统研发。传智教育架构师带头人，输送500+一线人才；智能体开发负责人，推动AI企业融合落地。"
          ],
        },
        {
          name: "姚",
          b: "AI大模型",
          p: "GIS行业工程实战专家",
          tag: ["GIS行业工程实战专家"],
          info: [

            "哈尔滨工程大学毕业，深耕GIS行业工程实战，多年图像分割、检测、追踪经验，参与多项国家级/部委级重大项目，拥有丰富的工程落地实战能力。",
          ],
        },
        {
          name: "唐僧",
          b: "AI测试",
          tag: ["10年多行业架构+大厂算法导师"],
          p: "10年多行业架构+大厂算法导师",
          info: [
            "大厂算法面试专家，首批大模型工程实践者，专注企业场景深度应用。覆盖电商、金融、办公自动化、在线教育项目架构。授课生动贴切，生活案例化繁为简。",
          ],
        },


        {
          name: "李",
          b: "AI测试",
          tag: ["985算法专家，央企互联网深耕"],
          p: "985算法专家，央企互联网深耕",

          info: [
            "资深算法工程师，专注数据挖掘、NLP、对话机器人、大模型。多年理论实践融合，授课擅数据分析可视化、信息抽取等核心技能。",
          ],
        },
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box7 {
  padding: 80px 0 58px;
  width: 100%;
  // background: url("../../../assets/coursePage/ai/box10/bg.png") no-repeat;
  // background-size: cover;

  .word {
    white-space: nowrap;
  }



  .teacher-box {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    margin: 48px auto 0 32px;

    .teacher {
      width: 328px;
      height: 448px;
      background: linear-gradient(121deg, #F7F7FF 0%, #E6F3FF 100%);
      border-radius: 40px;
      margin-right: 30px;
      margin-bottom: 30px;
      padding: 16px;
      box-sizing: border-box;
      position: relative;

      .teacher-inner {
        background: #FFFFFF;
        border-radius: 24px;
        padding: 32px 20px 40px 30px;
        margin-top: 250px;
        width: 100%;
        min-height: 164px;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;

      }

      img {
        width: 280px;
        position: absolute;
        top: 16px;
        left: 24px;

      }

      .tName {
        font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #0F2654;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        margin: 14px 0 8px;
      }

      p {
        font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #6E7F94;
        line-height: 36px;
        text-align: left;
        font-style: normal;

      }

      b {
        font-family: SourceHanSansSC, SourceHanSansSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #6E7F94;
        line-height: 36px;
        text-align: left;
        font-style: normal;
      }
    }

    div:nth-child(3),
    div:nth-child(4) {
      height: 484px;
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;

    box-sizing: border-box;

    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;

      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }

    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    .tag2 {
      height: 44px;
      background: #fff7e8;
      border-radius: 8px;

      color: #ff7d00;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
